import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import LayoutsList from './LayoutsList/LayoutsList';

const Layouts = ({ match }) => {
    return (
        <div className="Layouts">
            <ContainerWrapper container="layouts">
                <Route exact path={match.path} component={LayoutsList} />
                <Route exact path={ `${ match.url }/edit/:layoutId` } component={LayoutsList} />
            </ContainerWrapper>
        </div>
    );
}

export default Layouts;
